import { useEffect, useRef } from "react";

const SCRIPT_SRC = "https://b.sf-syn.com/badge_js?sf_id=4124674&variant_id=tbs";

function injectScript() {
  // Remove any prior copy so the vendor script re-runs and picks up
  // badge roots that mounted after its last execution (SPA navigation,
  // or a second instance such as the footer).
  document
    .querySelectorAll(`script[src="${SCRIPT_SRC}"]`)
    .forEach((s) => s.remove());
  const sc = document.createElement("script");
  sc.async = true;
  sc.src = SCRIPT_SRC;
  document.body.appendChild(sc);
}

/** Top Business Software "Most Loved" review badge. Script is injected client-side only. */
export function TbsBadge({ className = "" }: { className?: string }) {
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let attempts = 0;
    injectScript();
    const timer = window.setInterval(() => {
      attempts += 1;
      const rendered = rootRef.current?.querySelector("img");
      if (rendered || attempts > 4) {
        window.clearInterval(timer);
        return;
      }
      injectScript();
    }, 1200);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div
      ref={rootRef}
      className={`sf-root inline-flex normal-case tracking-normal ${className}`}
      data-id="4124674"
      data-badge="most-loved"
      data-variant-id="tbs"
      style={{ width: 100 }}
    >
      <a
        href="https://topbusinesssoftware.com/products/Monroya/reviews/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs text-muted-foreground underline-offset-2 hover:underline"
      >
        Monroya Reviews
      </a>
    </div>
  );
}
